import {Component} from "@angular/core";
import {TimezoneService} from "./timezone.service";

@Component({
  selector: 'app-timezone-picker',
  template: `
  <ion-item>
    <ion-label stacked>{{ 'profile.timezone' | translate }}</ion-label>
    <ion-select
      [(ngModel)]="timezone"
      cancelText="{{ 'global.cancel' | translate }}"
      okText="{{ 'global.ok' | translate }}"
      [ngModelOptions]="{standalone: true}"
      (ionChange)="setTimezone($event)"
    >
      <ion-option *ngFor="let tz of timezones" value="{{ tz }}">{{ tz }}</ion-option>
    </ion-select>
  </ion-item>
  `,
})
export class TimezonePickerComponent{
  timezone: string;
  timezones = [];

  constructor(
    private timezoneService: TimezoneService
  ) {
    this.timezone = timezoneService.getTimezone();
    this.timezones = timezoneService.timezones;
  }

  setTimezone(timezone) {
    this.timezoneService.setTimezone(timezone);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timezone-picker/timezone-picker.component.ts